import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import RecordPrices from "./RecordPrices.graphql";

export default function useRecordPrices() {
    return useMutation(gql(RecordPrices));
}
